/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { SubGroup_query$ref } from "./SubGroup_query.graphql";
export type route_SubGroup_QueryVariables = {
    readonly uuid: string;
};
export type route_SubGroup_QueryResponse = {
    readonly " $fragmentRefs": SubGroup_query$ref;
};
export type route_SubGroup_Query = {
    readonly response: route_SubGroup_QueryResponse;
    readonly variables: route_SubGroup_QueryVariables;
};



/*
query route_SubGroup_Query(
  $uuid: ID!
) {
  ...SubGroup_query
}

fragment SubGroup_query on Query {
  subGroup(uuid: $uuid) {
    name
    logoImageLocation
    ...Breadcrumb_subGroup
    id
  }
}

fragment Breadcrumb_subGroup on SubGroup {
  name
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "uuid",
    "type": "ID!",
    "defaultValue": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "route_SubGroup_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "SubGroup_query",
        "args": null
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "route_SubGroup_Query",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "subGroup",
        "storageKey": null,
        "args": [
          {
            "kind": "Variable",
            "name": "uuid",
            "variableName": "uuid"
          }
        ],
        "concreteType": "SubGroup",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "logoImageLocation",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "route_SubGroup_Query",
    "id": null,
    "text": "query route_SubGroup_Query(\n  $uuid: ID!\n) {\n  ...SubGroup_query\n}\n\nfragment SubGroup_query on Query {\n  subGroup(uuid: $uuid) {\n    name\n    logoImageLocation\n    ...Breadcrumb_subGroup\n    id\n  }\n}\n\nfragment Breadcrumb_subGroup on SubGroup {\n  name\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'fa6937baa3eb0b50497bf1a41e488f99';
export default node;
